import React from 'react';
import * as Styled from './styled';
import { SearchElements } from '../SearchElements';
import * as palette from '@mlc/mlc-palette';
import { faUsers } from '@fortawesome/pro-regular-svg-icons';
import { connect } from 'react-redux';

interface State {
	shouldDisplayFilters: boolean;
}

interface ClientGroupsProps {
	filterCount: number;
	theme: 'dark' | 'light';
}

interface ReduxProps {
	filterCount: number;
}

type Props = ClientGroupsProps & ReduxProps;

const initialState: State = {
	shouldDisplayFilters: false,
};

/*
    Putting the button + menu in one component makes it more reusable but for it's proper styling it needs certain parent,
    grandparent, etc. elements to not have position: relative so it can position correctly. There probably is a better way
    to do this
*/
export const ViewGroupsButton = (props: Props) => {
	const textColour =
		props.theme === 'dark' ? palette.mlcText : palette.mlcWhite;

	return (
		<Styled.FiltersWrapper>
			<Styled.FilterMenuIcon icon={faUsers} size="1x" color={textColour} />
			<Styled.Anchor
				data-id={SearchElements.viewClientGroup}
				href="/masterkeyWeb/execute/GroupList"
				analyticsId="view-client-groups"
			>
				<Styled.ViewGroupLabel color={textColour}>
					View client groups
				</Styled.ViewGroupLabel>
			</Styled.Anchor>
		</Styled.FiltersWrapper>
	);
};

export const mapStateToProps = ({ search }: any): ReduxProps => ({
	filterCount: search.filterCount,
});

export default connect(mapStateToProps)(ViewGroupsButton);
